import { put, takeEvery, takeLatest } from 'redux-saga/effects';
import { Notify } from '@flexisaf/flexibull2';
import request from 'utils/request';
import urls from 'utils/config';
import { networkErrorHandler } from 'utils/errrorHandlers';
import EligibilityActionTypes from './types';
import {
  fetchRuleSetsSuccess,
  fetchRuleSetsFailure,
  saveRuleSetSuccess,
  saveRuleSetFailure,
  deleteRuleSetSuccess,
  deleteRuleSetFailure,
  previewEligibilitySuccess,
  previewEligibilityFailure,
  fetchRuleSets,
} from './actions';

const { API_BASE_URL } = urls || {};

function* fetchRuleSetsSaga({ payload: { applicationId } }) {
  const response = yield request({
    method: 'get',
    url: `${API_BASE_URL}/applications/${applicationId}/eligibility/rule-sets`,
  });
  if (response.success) {
    yield put(fetchRuleSetsSuccess(response.raw));
  } else {
    networkErrorHandler(
      response?.statusCode,
      `Failed to load eligibility rule sets: ${response.message}`
    );
    yield put(fetchRuleSetsFailure(response.message));
  }
}

function* saveRuleSetSaga({ payload: { applicationId, data, ruleSetId, cb } }) {
  const isUpdate = Boolean(ruleSetId);
  const response = yield request({
    method: isUpdate ? 'put' : 'post',
    url: isUpdate
      ? `${API_BASE_URL}/applications/${applicationId}/eligibility/rule-sets/${ruleSetId}`
      : `${API_BASE_URL}/applications/${applicationId}/eligibility/rule-sets`,
    data,
  });
  if (response.success) {
    yield put(saveRuleSetSuccess(response.raw));
    Notify(isUpdate ? 'Rule set updated' : 'Rule set created', {
      status: 'success',
    });
    yield put(fetchRuleSets(applicationId));
    if (cb) cb(response.raw);
  } else {
    networkErrorHandler(
      response?.statusCode,
      `Failed to save rule set: ${response.message}`
    );
    yield put(saveRuleSetFailure(response.message));
  }
}

function* deleteRuleSetSaga({ payload: { applicationId, ruleSetId, cb } }) {
  const response = yield request({
    method: 'delete',
    url: `${API_BASE_URL}/applications/${applicationId}/eligibility/rule-sets/${ruleSetId}`,
  });
  if (response.success) {
    yield put(deleteRuleSetSuccess(ruleSetId));
    Notify('Rule set deleted', { status: 'success' });
    yield put(fetchRuleSets(applicationId));
    if (cb) cb();
  } else {
    networkErrorHandler(
      response?.statusCode,
      `Failed to delete rule set: ${response.message}`
    );
    yield put(deleteRuleSetFailure(response.message));
  }
}

function* previewEligibilitySaga({ payload: { applicationId, data, cb } }) {
  const response = yield request({
    method: 'post',
    url: `${API_BASE_URL}/applications/${applicationId}/eligibility/preview`,
    data,
  });
  if (response.success) {
    yield put(previewEligibilitySuccess(response.raw));
    if (cb) cb(response.raw);
  } else {
    networkErrorHandler(
      response?.statusCode,
      `Eligibility preview failed: ${response.message}`
    );
    yield put(previewEligibilityFailure(response.message));
  }
}

export default function* eligibilitySaga() {
  yield takeLatest(EligibilityActionTypes.FETCH_RULE_SETS, fetchRuleSetsSaga);
  yield takeEvery(EligibilityActionTypes.SAVE_RULE_SET, saveRuleSetSaga);
  yield takeEvery(EligibilityActionTypes.DELETE_RULE_SET, deleteRuleSetSaga);
  yield takeLatest(
    EligibilityActionTypes.PREVIEW_ELIGIBILITY,
    previewEligibilitySaga
  );
}
